import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import PostCategoryPage from "../pages/PostCategory/PostCategoryPage";
import PagePage from "../pages/Page/PagePage";

const PrivateRoutes = () => {
    const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
    const MenuPage = lazy(() => import('../pages/Menu/MenuPage'))
    const BaseConfigPage = lazy(() => import('../pages/BaseConfig/BaseConfigPage'))
    const AdvertisingPage = lazy(() => import('../pages/Advertising/AdvertisingPage'))
    const PostCategoryPage = lazy(() => import('../pages/PostCategory/PostCategoryPage'))
    const PostPage = lazy(() => import('../pages/Post/PostPage'))
    const ElementPage = lazy(() => import('../pages/Elemnt/ElementPage'))
    const UserManagement = lazy(() => import('../pages/ClientManagment/UserManagement'))
    const CategoryPage = lazy(() => import('../pages/ProductCategory/CategoryPage'))
    const BrandPage = lazy(() => import('../pages/Brand/BrandPage'))
    const ProductPropertyGroupPage = lazy(() => import('../pages/ProductPropertyGroup/ProductPropertyGroupPage'))
    const ProductPropertyNamePage = lazy(() => import('../pages/ProductPropertyName/ProductPropertyNamePage'))
    const ProductPage = lazy(() => import('../pages/Product/ProductPage'))
    const AuthorizeKeysPage = lazy(() => import('../pages/ConnectUrl/AuthorizeKeysPage'))
    const FeedReaderPage = lazy(() => import('../pages/FeedReader/FeedReaderPage'))

    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/dashboard'/>}/>
                {/* Pages */}
                <Route path='dashboard' element={<DashboardWrapper/>}/>
                <Route path='builder' element={<BuilderPageWrapper/>}/>
                {/* Lazy Modules */}
                <Route
                    path='crafted/account/*'
                    element={
                        <SuspensedView>
                            <AccountPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/Menu/*'
                    element={
                        <SuspensedView>
                            <MenuPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/BaseConfig/*'
                    element={
                        <SuspensedView>
                            <BaseConfigPage/>
                        </SuspensedView>
                    }
                />

                <Route
                    path='apps/Advertising/*'
                    element={
                        <SuspensedView>
                            <AdvertisingPage/>
                        </SuspensedView>
                    }
                />
 <Route
                    path='apps/PostTypes/*'
                    element={
                        <SuspensedView>
                            <PostCategoryPage/>
                        </SuspensedView>
                    }
                />
 <Route
                    path='apps/Post/*'
                    element={
                        <SuspensedView>
                            <PostPage/>
                        </SuspensedView>
                    }
                />
                 <Route
                    path='apps/Page/*'
                    element={
                        <SuspensedView>
                            <PagePage/>
                        </SuspensedView>
                    }
                />

<Route
                    path='apps/Element/*'
                    element={
                        <SuspensedView>
                            <ElementPage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='apps/Users/*'
                    element={
                        <SuspensedView>
                            <UserManagement/>
                        </SuspensedView>
                    }
                />
<Route
                    path='Product/Category/*'
                    element={
                        <SuspensedView>
                            <CategoryPage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='Product/Brand/*'
                    element={
                        <SuspensedView>
                            <BrandPage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='Product/ProductPropertyGroup/*'
                    element={
                        <SuspensedView>
                            <ProductPropertyGroupPage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='Product/PropertyName/*'
                    element={
                        <SuspensedView>
                            <ProductPropertyNamePage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='Product/Store/*'
                    element={
                        <SuspensedView>
                            <ProductPage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='Authorize/*'
                    element={
                        <SuspensedView>
                            <AuthorizeKeysPage/>
                        </SuspensedView>
                    }
                />
<Route
                    path='apps/FeedReader/*'
                    element={
                        <SuspensedView>
                            <FeedReaderPage/>
                        </SuspensedView>
                    }
                />


                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404'/>}/>
            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>
}

export {PrivateRoutes}
